<template>
  <CModal :title="title" :show.sync="show" :closeOnBackdrop="false">
    <p v-if="count === 1">Sim <strong>{{ label }}</strong></p>
    <p v-else>Áp dụng cho <strong>{{ count }} sim</strong>.</p>
    <p v-if="mode === 'cancel'">
      Hủy kích hoạt sẽ xóa ngày kích hoạt, ngày bắt đầu, ngày hết hạn và ngày gia hạn.
      Sau đó có thể kích hoạt lại.
    </p>
    <template v-else>
      <div v-if="mode !== 'extend'" class="form-group">
        <label>Ngày bắt đầu <span class="required">*</span></label>
        <DatePicker
          v-model="startDateValue"
          locale="vi"
          class="datepicker"
          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
          :popover="{ visibility: 'click', positionFixed: true }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input class="form-control" :value="inputValue" v-on="inputEvents" placeholder="dd/MM/yyyy" readonly />
          </template>
        </DatePicker>
      </div>
      <div class="form-group">
        <label>Số tháng gói</label>
        <input type="number" min="1" max="60" class="form-control" v-model.number="months" />
        <div class="mt-2">
          <CButton
            v-for="item in monthOptions"
            :key="item"
            size="sm"
            class="mr-1 mb-1"
            :color="months === item ? 'primary' : 'secondary'"
            @click="months = item"
          >
            {{ item }} tháng
          </CButton>
        </div>
      </div>
      <div class="form-group">
        <label>
          Ngày hết hạn
          <span v-if="mode !== 'extend' || count === 1" class="required">*</span>
        </label>
        <DatePicker
          v-model="expireDateValue"
          locale="vi"
          class="datepicker"
          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
          :popover="{ visibility: 'click', positionFixed: true }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input class="form-control" :value="inputValue" v-on="inputEvents" placeholder="dd/MM/yyyy" readonly />
          </template>
        </DatePicker>
        <small v-if="mode === 'extend' && count > 1" class="text-muted">
          Để trống thì mỗi sim được cộng số tháng vào ngày hết hạn của sim đó. Nếu đã quá hạn thì tính từ hôm nay.
          Nhập ngày ở đây nếu muốn tất cả cùng một ngày hết hạn.
        </small>
        <small v-else-if="mode === 'extend'" class="text-muted">
          Số tháng cộng vào ngày hết hạn hiện tại. Có thể sửa lại ngày hết hạn trước khi lưu.
        </small>
        <small v-else class="text-muted">Số tháng tính ra ngày hết hạn. Có thể sửa lại ngày này trước khi lưu.</small>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-secondary" @click="show = false">Đóng</button>
      <button type="button" class="btn" :class="mode === 'cancel' ? 'btn-danger' : 'btn-primary'" :disabled="loading.value" @click="submit">
        {{ mode === 'cancel' ? 'Hủy kích hoạt' : 'Lưu' }}
      </button>
    </template>
  </CModal>
</template>

<script>
import { DatePicker } from "v-calendar";

export default {
  name: "SimPackageForm",
  components: { DatePicker },
  notifications: {
    showErrorMsg: { type: "error", title: "Error" }
  },
  data() {
    return {
      show: false,
      mode: "activate",
      simIds: [],
      label: "",
      count: 0,
      startDate: "",
      expireDate: "",
      baseExpire: "",
      months: 12,
      monthOptions: [1, 3, 6, 12, 24],
      suspend: false,
      loading: { value: false }
    };
  },
  computed: {
    title() {
      if (this.mode === "extend") {
        return "Gia hạn sim";
      }
      if (this.mode === "correct") {
        return "Sửa kích hoạt";
      }
      if (this.mode === "cancel") {
        return "Hủy kích hoạt";
      }
      return "Kích hoạt sim";
    },
    startDateValue: {
      get() {
        return this.toDate(this.startDate);
      },
      set(value) {
        this.startDate = this.toISO(value);
      }
    },
    expireDateValue: {
      get() {
        return this.toDate(this.expireDate);
      },
      set(value) {
        this.expireDate = this.toISO(value);
      }
    }
  },
  watch: {
    startDate() {
      this.applyMonths();
    },
    months() {
      this.applyMonths();
    }
  },
  methods: {
    open(sim, mode) {
      this.openList([sim], mode);
    },
    openList(sims, mode) {
      const rows = sims || [];
      this.simIds = rows.map(function (sim) {
        return sim.simId || sim.id;
      }).filter(function (id) {
        return id !== null && id !== undefined && id !== "";
      });
      this.count = this.simIds.length;
      this.label = rows.length === 1 ? (rows[0].imei || rows[0].phone || rows[0].iccid || "") : "";
      this.mode = mode || "activate";
      const one = rows.length === 1 ? rows[0] : null;
      this.suspend = true;
      this.months = 12;
      this.baseExpire = one ? this.toISO(one.expireDate) : "";
      if (this.mode === "correct" && one) {
        this.startDate = this.toISO(one.startDate) || this.todayISO();
        this.expireDate = this.toISO(one.expireDate);
      } else if (this.mode === "extend") {
        this.startDate = "";
        this.expireDate = one ? this.addMonths(this.laterISO(this.baseExpire, this.todayISO()), this.months) : "";
      } else if (this.mode === "cancel") {
        this.startDate = "";
        this.expireDate = "";
      } else {
        this.startDate = this.todayISO();
        this.expireDate = this.addMonths(this.startDate, this.months);
      }
      this.show = true;
      this.$nextTick(() => {
        this.suspend = false;
      });
    },
    applyMonths() {
      if (this.suspend || this.mode === "cancel") {
        return;
      }
      if (this.mode === "extend" && this.count > 1) {
        return;
      }
      const months = Number(this.months);
      if (!months || months < 1) {
        return;
      }
      const base = this.mode === "extend"
        ? this.laterISO(this.baseExpire, this.todayISO())
        : this.startDate;
      if (!base) {
        return;
      }
      this.expireDate = this.addMonths(base, months);
    },
    todayISO() {
      return this.formatISO(new Date());
    },
    toISO(value) {
      const date = this.toDate(value);
      return date ? this.formatISO(date) : "";
    },
    toDate(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
      }
      if (typeof value === "string" && value.indexOf("-") === 4) {
        const parts = value.substring(0, 10).split("-");
        return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      }
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    laterISO(value, today) {
      if (!value) {
        return today;
      }
      return value < today ? today : value;
    },
    formatISO(date) {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return date.getFullYear() + "-" + month + "-" + day;
    },
    addMonths(iso, months) {
      const date = new Date(iso + "T00:00:00");
      const day = date.getDate();
      date.setMonth(date.getMonth() + Number(months));
      if (date.getDate() < day) {
        date.setDate(0);
      }
      return this.formatISO(date);
    },
    submit() {
      let that = this;
      if (!this.simIds.length) {
        this.showErrorMsg({ message: "Chưa chọn sim" });
        return;
      }
      const months = Number(this.months);
      const payload = { ids: this.simIds };
      let url = "/sim/activate";
      if (this.mode === "cancel") {
        url = "/sim/cancel-activation";
      } else if (this.mode === "extend") {
        url = "/sim/extend";
        if ((!months || months < 1 || months > 60) && !this.expireDate) {
          this.showErrorMsg({ message: "Chọn số tháng hoặc ngày hết hạn" });
          return;
        }
        if (months >= 1 && months <= 60) {
          payload.months = months;
        }
        if (this.expireDate) {
          payload.expireDate = this.expireDate;
        } else if (this.count === 1) {
          this.showErrorMsg({ message: "Chọn ngày hết hạn" });
          return;
        }
      } else {
        url = this.mode === "correct" ? "/sim/correct" : "/sim/activate";
        if (!this.startDate) {
          this.showErrorMsg({ message: "Chọn ngày bắt đầu" });
          return;
        }
        if (!this.expireDate) {
          this.showErrorMsg({ message: "Chọn ngày hết hạn" });
          return;
        }
        if (this.expireDate <= this.startDate) {
          this.showErrorMsg({ message: "Ngày hết hạn phải sau ngày bắt đầu" });
          return;
        }
        payload.startDate = this.startDate;
        payload.expireDate = this.expireDate;
        if (months >= 1 && months <= 60) {
          payload.months = months;
        }
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: url,
        dataSubmit: function () {
          return payload;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            return;
          }
          const data = response.data.data;
          const rows = Array.isArray(data) ? data : [data || { id: that.simIds[0] }];
          that.show = false;
          that.$emit("saved", rows);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  }
};
</script>
